var render = function render(){var _vm=this,_c=_vm._self._c;return _c('route-table-list',{attrs:{"default-hidden-columns":['public_scope'],"hidden-columns":['brand', 'region', 'account', 'vpc'],"id":_vm.id,"getParams":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }